import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';

import { LogoSVG } from '../../../assets/svg/index';
import { CardMedia } from '@mui/material';

const BannerCH = () => (
  <>
    <CssBaseline />
    <Grid
      item
      xs={12}
      sm={4}
      md={7}
      sx={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <video autoPlay loop muted style={{height: '100%', width: '100%', objectFit: 'cover'}}>
        <source src='https://cinemahive.s3.amazonaws.com/videos/Hero_1.mp4' type='video/mp4'/>
      </video>
        <Grid item sx={{ width: '500px', maxWidth: '90%', maxHeigth: '90%', position: 'absolute' }}>
          <LogoSVG />
        </Grid>
    </Grid>
  </>
)

export default BannerCH;
